import i18next, { TOptions } from 'i18next';

import { i18nextInit, useTypedTranslationTemplate } from '@fora-monorepo/webapp-i18n';

import components__global__base from './ditto/components__global__base.json';
import components_employer_my_pages from './ditto/components__employer-my-pages__base.json';
import { envConfig } from '../config';

const dittoCopySV = {
  ...components__global__base,
  ...components_employer_my_pages,
};

i18nextInit({ localCopySV: {}, dittoCopySV, debugMode: !!envConfig.devLogging });

export type DittoKeys = keyof typeof dittoCopySV;

export const i18nextInstance = i18next;

export const useTypedTranslation = useTypedTranslationTemplate<DittoKeys>;

export type TypedTFunction = ReturnType<typeof useTypedTranslation>['t'];

export const typedT = (key: DittoKeys, options?: TOptions) => i18nextInstance.t(key, options);
